import { getTrackingUserId, helloRetailRecommendationKey } from "customHRUtils";

document.addEventListener('DOMContentLoaded', async () => {
  const loadRecoms = async (requests) => {
    const data = {
      websiteUuid: window.themeVariables.settings.helloRetailId,
      trackingUserId: await getTrackingUserId(),
      requests: requests,
    };

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    const response = await fetch("https://core.helloretail.com/serve/recoms", options);
    return await response.json();
  }

  const fields = ["extraData","originalUrl", "trackingCode"];

  const recoms = document.querySelectorAll('recommended-products');
  const requests = Array.from(recoms).map((recom) => {
    const key = helloRetailRecommendationKey(recom.dataset.key);
    const request = {
      format: "json",
      key: key,
      fields: fields
    };

    if (recom.dataset.collection) {
      request['context'] = { "hierarchies": [[recom.dataset.collection]]};
    }

    if (recom.dataset.productId) {
      request['context'] = { "productNumbers": [recom.dataset.productId]};
    }
    return request;
  });

  const cartRecommendations = (items) => {
    const mappedItems = items && items.map(item => item.product_id.toString());
    const productNumbers = mappedItems ?? window.themeVariables.cart.itemIds.map(id => id.toString());
    if (window.themeVariables.currentProductId) {
      productNumbers.push(window.themeVariables.currentProductId.toString());
    }

    const mql = window.matchMedia("(min-width: 1000px)");
    let recommendationKey = helloRetailRecommendationKey(
      window.themeVariables.settings.cartRecommendationKeyMobile,
    );

    if (mql.matches) {
      recommendationKey = helloRetailRecommendationKey(
        window.themeVariables.settings.cartRecommendationKeyDesktop,
      );
    }

    return [
      {
        format: "json",
        key: recommendationKey,
        fields: fields,
        context: {
          productNumbers: productNumbers
        }
      }
    ]
  }

  const responses = await loadRecoms([...requests, ...cartRecommendations()]);
  document.dispatchEvent(new CustomEvent('recoms-loaded', { detail: responses }));

  const loadCartRecoms = async (event) => {
    const responses = await loadRecoms([...cartRecommendations(event.detail.cart.items)]);
    document.dispatchEvent(new CustomEvent('cart:recoms-loaded', { detail: responses }));
  }

  document.addEventListener("variant:add", (event) => loadCartRecoms(event));
  document.addEventListener("cart:change", (event) => loadCartRecoms(event));
});